<div class="analysis-summary">
  <section class="analysis-summary__hero">
    <header class="analysis-summary__hero__header">
      <span class="analysis-summary__hero__label">PENDENTES DE ANÁLISE</span>
      <span class="analysis-summary__hero__dot"></span>
    </header>

    <div class="analysis-summary__hero__value">
      <strong>{{ totals.pending }}</strong>
      <span>{{ documentsLabel }} em {{ totals.companies }} {{ companiesLabel }}</span>
    </div>

    <app-document-analysis-composition-bar
      [pending]="totals.pending"
      [approved]="totals.approved"
      [rejected]="totals.rejected"
      [height]="'6px'"></app-document-analysis-composition-bar>

    <p class="analysis-summary__hero__caption">
      {{ totals.pendingPercent }}% do total de {{ totals.total }} documentos
    </p>
  </section>

  <section class="analysis-summary__stats">
    <div class="analysis-summary__stat analysis-summary__stat--total">
      <span class="analysis-summary__stat__label">TOTAL DE DOCUMENTOS</span>
      <strong class="analysis-summary__stat__value">{{ totals.total }}</strong>
      <span class="analysis-summary__stat__hint">pendentes + aprovados + rejeitados</span>
    </div>

    <div class="analysis-summary__stat analysis-summary__stat--approved">
      <span class="analysis-summary__stat__label">APROVADOS</span>
      <strong class="analysis-summary__stat__value">{{ totals.approved }}</strong>
      <span class="analysis-summary__stat__hint">{{ totals.approvedPercent }}% do total</span>
    </div>

    <div class="analysis-summary__stat analysis-summary__stat--rejected">
      <span class="analysis-summary__stat__label">REJEITADOS</span>
      <strong class="analysis-summary__stat__value">{{ totals.rejected }}</strong>
      <span class="analysis-summary__stat__hint">{{ totals.rejectedPercent }}% do total</span>
    </div>
  </section>
</div>
